import { sendErrorNotice, sendSuccessNotice, refreshResource } from '@/commons/utils';
import { upload_file, request_list, request_detail, export_list } from '@/commons/hpod';
import Vue from 'vue';
import Crud from './crud'
import configs from '@/configs';
var FileSaver = require('file-saver');
var crud = new Crud('products', 'hàng hóa');

const state = {
    ...crud.state,
    availableList: [],
    orderList: {},
    quoteList: {},
    billList: {},
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    import_data({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(crud.endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason);
            }
            else {
                refreshResource();
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
                FileSaver.saveAs(blob, `Import_Result_${new Date().getTime()}.xlsx`);
                sendSuccessNotice('Import file thành công.');
            }
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
    import_excel_tmdt({ commit }, formData) {
        return new Promise((resolve) => {
            commit("setLoading", { loading: true });
            Vue.http.post(
                `${configs.API}/api/${crud.endpoint}/import_excel_tmdt/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.authentication.token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                }
            ).then(res => {
                commit("setLoading", { loading: false });
                refreshResource();
                resolve({ success: true, data: res.data.data || res.data });
            }, err => {
                commit("setLoading", { loading: false });
                resolve({
                    success: false,
                    reason: err && err.body && err.body.reason ? err.body.reason : 'Import thất bại'
                });
            });
        });
    },
    getAvailableList({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list(`${crud.endpoint}/available`, data => {
                    commit('setAvailableList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, param, this.state.authentication.token);
            }, 100)
        })
    },
    getPackageTemplates({ commit }, customerId) {
        return new Promise((resolve, reject) => {
            if (!customerId) {
                resolve([]);
                return;
            }

            Vue.http.get(`${configs.API}/api/${crud.endpoint}/package-templates/${customerId}`, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(response => {
                if (response.data.status === 200) {
                    resolve(response.data.data || []);
                } else {
                    reject(response.data.reason || 'Không thể tải danh sách tên sản phẩm.');
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    getOrderList({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/order`, data => {
                    commit('setOrderList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    getBillList({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/bill`, data => {
                    commit('setBillList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    getQuoteList({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/quote`, data => {
                    commit('setQuoteList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('products', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `ma_bill_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
    exportTieuNgach({ commit }, param) {
        return new Promise((resolve, reject) => {
            commit("setLoading", { loading: true });
            export_list('products', res => {
                commit("setLoading", { loading: false });
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
                FileSaver.saveAs(blob, `tieu_ngach_${new Date().getTime()}.xlsx`);
                resolve(res);
            }, Vue.http, param, this.state.authentication.token, 'export_tieu_ngach', error => {
                commit("setLoading", { loading: false });
                sendErrorNotice('Lỗi khi xuất file tiểu ngạch!');
                reject(error);
            });
        });
    },
    exportChinhNgach({ commit }, param) {
        return new Promise((resolve, reject) => {
            commit("setLoading", { loading: true });
            export_list('products', res => {
                commit("setLoading", { loading: false });
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
                FileSaver.saveAs(blob, `导出文件-大额贸易_${new Date().getTime()}.xlsx`);
                resolve(res);
            }, Vue.http, param, this.state.authentication.token, 'export_chinh_ngach', error => {
                commit("setLoading", { loading: false });
                sendErrorNotice('Lỗi khi xuất file chính ngạch!');
                reject(error);
            });
        });
    },
    exportChinhNgachVi({ commit }, param) {
        return new Promise((resolve, reject) => {
            commit("setLoading", { loading: true });
            export_list('products', res => {
                commit("setLoading", { loading: false });
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
                FileSaver.saveAs(blob, `chinh_ngach_vi_${new Date().getTime()}.xlsx`);
                resolve(res);
            }, Vue.http, param, this.state.authentication.token, 'export_chinh_ngach_vi', error => {
                commit("setLoading", { loading: false });
                sendErrorNotice('Lỗi khi xuất file chính ngạch!');
                reject(error);
            });
        });
    },
};
const mutations = {
    ...crud.mutations,
    setAvailableList(state, ret) {
        state.availableList = ret.data;
    },
    setOrderList(state, ret) {
        state.orderList = ret;
    },
    setQuoteList(state, ret) {
        state.quoteList = ret;
    },
    setBillList(state, ret) {
        state.billList = ret;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
